import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardFooter, MDBIcon, MDBTable, MDBTableBody
} from 'mdb-react-ui-kit';

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import UserProfileModal from './UserProfileModal';
export default function User({ employee }) {
    const [showUserProfileModal, setShowUserProfileModal] = useState(false);


    return (
<>
    <div className='d-flex flex-column justify-content-center align-items-center'>
        <MDBCard className='text-center rounded mb-3'>
            <MDBCardBody className='d-flex flex-column flex-md-row justify-content-between align-items-center'>
                {employee.picture && (
                    <img
                        src={employee.picture}
                        alt=''
                        style={{ width: "150px" }}
                        className='rounded'
                    />
                )}
                <MDBTable align="middle" bordered striped>
                    <MDBTableBody>
                        {Object.entries(employee).map(([key, value]) => {
                            // Exclude picture and subDomains keys
                            if (key !== 'loggedIn' && key !== 'picture' && key !== 'domainToGroupMap' && key !== 'email' && key !== 'ou' && key !== 'dn' && key !== 'password') {
                                if (key === 'domains') {
                                    return (
                                        <tr key={key}>
                                            <th style={{ textAlign: 'left' }} scope='row'>Domains</th>
                                            <td style={{ textAlign: 'left' }}>
                                                {Object.values(value).map((domain, index) => (
                                                    <div key={index}>{domain}</div>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                } else if (key === 'groups' && Array.isArray(value)) {
                                    // Render groups field
                                    return (
                                        <tr key={key}>
                                            <th style={{ textAlign: 'left' }} scope="row">Groups</th>
                                            <td style={{ textAlign: 'left' }}>
                                                {value.map((group, index) => (
                                                    <div key={index}>{group.groupName}</div>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    return (
                                        <tr key={key}>
                                            <th style={{ textAlign: 'left' }} scope='row'>{key.charAt(0).toUpperCase() + key.slice(1)}</th>
                                            <td style={{ textAlign: 'left' }}>{value}</td>
                                        </tr>
                                    );
                                }
                            }
                        })}
                    </MDBTableBody>
                </MDBTable>
            </MDBCardBody>
            <MDBCardFooter background='light' border='0' className='p-2 d-flex justify-content-around'>
                <MDBBtn color='link' rippleColor='primary' className='text-reset m-0'>
                    <MDBIcon fas icon='envelope' />
                </MDBBtn>
                <MDBBtn color='link' rippleColor='primary' className='text-reset m-0'>
                    <MDBIcon fas icon='phone' />
                </MDBBtn>
                <MDBBtn size='sm' rounded color='link' onClick={() => setShowUserProfileModal(true)}>
                    Edit
                </MDBBtn>
            </MDBCardFooter>
        </MDBCard>
    </div>
    <UserProfileModal setShowUserProfileModal={setShowUserProfileModal} showUserProfileModal={showUserProfileModal} userId={employee.uid} user={employee} />
</>



    );
}
User.propTypes = {
    employee: PropTypes.shape({
      uid: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      commonName: PropTypes.string,
      ou: PropTypes.string,
      images: PropTypes.array,
      picture: PropTypes.string,
      domainToGroupMap: PropTypes.object,
      dn: PropTypes.string,
      firm: PropTypes.string,
      description: PropTypes.string,
      password: PropTypes.string,
      loggedIn: PropTypes.bool,
      subDomains: PropTypes.array,
      date: PropTypes.string,
      title: PropTypes.string,
    }),
    loggedIn: PropTypes.bool,
  };
  
